import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";

import imgOne from "../images/2ba41b173317965.648e201215428.jpg";
import imgTwo from "../images/39bcbd130801465.61884f3bc7fa8.jpg";
import imgThree from "../images/c0dd4075725251.5c802551dff8c.jpg";
import imgFour from "../images/defa5075843643.5c5881e5ca19f.jpg";
import imgFive from "../images/IMG_9141.jpg";

export default function CarouselGallery() {
  const theme = useTheme();

  const imgs = [imgOne, imgTwo, imgThree, imgFour, imgFive];
  const titles = [
    "SINCERE MOMENT",
    "REAL CONNECTIONS",
    "TIMELESS MEMORIES",
    "ENDLESS REMINISCENCES",
    "LASTING IMPRESSIONS",
  ];

  return (
    <Carousel
      autoPlay={true}
      infiniteLoop={true}
      showThumbs={false}
      showStatus={false}
      swipeable={true}
      emulateTouch={true}
      interval={3500}
      transitionTime={1000}
    >
      {imgs.map((img, idx) => (
        <Box key={idx}>
          <img src={img} alt={titles[idx]} />
          <Typography
            color={"primary"}
            fontSize={{ xs: "0.9rem", md: "2.6rem" }}
            sx={{
              position: "absolute",
              bottom: { xs: theme.spacing(4), md: theme.spacing(12) },
              right: "15%",
              left: "15%",
            }}
            letterSpacing={".15em"}
          >
            {titles[idx]}
          </Typography>
        </Box>
      ))}
    </Carousel>
  );
}
